import { createAPIService } from './api.service';

export const ROLE_ENDPOINT = '/user/api/v2/admin/roles';

const service = createAPIService(ROLE_ENDPOINT);

// endpoints
service.getRoles = async params =>
  (await service.get('', { params: params })).data;

service.getRole = async id => (await service.get(`/${id}`)).data;

service.createRole = async role => (await service.post('', role)).data;

service.updateRole = async (id, role) =>
  (await service.patch(`/${id}`, role)).data;

service.deleteRole = async id => (await service.delete(`/${id}`)).data;

// Role policies
service.getRolePolicies = async (id, params) =>
  (await service.get(`/${id}/policies`, { params: params })).data;

service.addRolePolicies = async (id, policies) =>
  (await service.post(`/${id}/policies`, policies)).data;

service.deleteRolePolicies = async (id, policies) =>
  (await service.delete(`/${id}/policies?ids=${policies.join()}`)).data;

export default service;
